import { gsap } from "gsap";


export class GSAPCountdown {
  constructor(elements, options = {}) {
    this.options = {
      fadeInDuration: 0.2,
      fadeOutDuration: 0.2,
      holdTime: 0.5,
      delayBetween: 0,
      startScale: 0.8,
      endScale: 1,
      easeIn: "power2.out",
      easeOut: "power2.in",
      initialAlpha: 0,
      finalAlpha: 1,
      reverse: false,
      onComplete: () => {},
      ...options
    };

    this.elements = this._normalize(elements);
    if (this.options.reverse) this.elements.reverse();

    this.tl = gsap.timeline({
      paused: true,
      onComplete: this.options.onComplete
    });

    this._init();
  }

  _normalize(elements) {
    if (typeof elements === "string") {
      return gsap.utils.toArray(elements);
    }
    return Array.from(elements);
  }

  _init() {
    const o = this.options;

    // Set initial state
    gsap.set(this.elements, {
      autoAlpha: o.initialAlpha,
      scale: o.startScale
    });

    this.elements.forEach((el, i) => {
      this.tl
        .fromTo(
          el,
          { autoAlpha: o.initialAlpha, scale: o.startScale },
          {
            autoAlpha: o.finalAlpha,
            scale: o.endScale,
            duration: o.fadeInDuration,
            ease: o.easeIn
          }
        )
        .to(el, {}, `+=${o.holdTime}`)
        .to(el, {
          autoAlpha: o.initialAlpha,
          scale: o.startScale,
          duration: o.fadeOutDuration,
          ease: o.easeOut
        });

      if (o.delayBetween > 0 && i !== this.elements.length - 1) {
        this.tl.to({}, { duration: o.delayBetween });
      }
    });
  }

  play() {
    this.tl.play(0);
  }

  pause() {
    this.tl.pause();
  }

  restart() {
    this.tl.restart();
  }

  kill() {
    this.tl.kill();
  }
}